import * as React from 'react'
import type { SkeletonSwitchProps } from './SkeletonSwitch'

type SkeletonSwitchWrapperProps = Pick<
  SkeletonSwitchProps,
  'animation' | 'loading'
>

export const SkeletonSwitchContext = React.createContext<
  Partial<SkeletonSwitchWrapperProps>
>({})

interface SkeletonSwitchProviderProps extends SkeletonSwitchWrapperProps {
  children: React.ReactNode
}

export const SkeletonSwitchProvider = ({
  children,
  ...other
}: SkeletonSwitchProviderProps) => {
  return (
    <SkeletonSwitchContext.Provider value={other}>
      {children}
    </SkeletonSwitchContext.Provider>
  )
}
